import React, { useEffect, useRef, useState } from "react";
// import { Icons } from "../../themes";
import classNames from "classnames";
import styles from "./SelectInput.module.scss";

const SelectInput = ({
  id,
  label,
  options,
  setOption,
  className,
  removeSelect,
}) => {
  const [display, setDisplay] = useState(false);
  const wrapperRef = useRef(null);
  const inputRet = useRef();
  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  });
  const [value, setValue] = useState({ name: "" });

  const handleClickOutside = (event) => {
    const { current: wrap } = wrapperRef;
    if (wrap && !wrap.contains(event.target)) {
      setDisplay(false);
    }
  };

  const updateState = (value) => {
    if (removeSelect) {
      setValue({ name: "" });
    } else {
      setValue(value);
    }
    setOption(value);
    setDisplay(false);
  };

  const onInputClick = () => {
    if (!display) {
      setDisplay(!display);
    }
  };

  useEffect(() => {
    if (!value.name.trim().length) {
      setOption({ name: "" });
    }
  }, [value]);

  return (
    <div
      ref={wrapperRef}
      className={classNames(
        styles.selectContainer,
        display && styles.selectContainerClicked,
        className
      )}
    >
      <input
        id={id}
        onClick={onInputClick}
        value={value.name}
        onChange={(event) =>
          setValue((prop) => ({ ...prop, name: event.target.value }))
        }
        ref={inputRet}
        placeholder={label}
        autoComplete="off"
      />
      {display && (
        <div className={styles.selectContainerOptions}>
          {options
            .filter((item) =>
              item.name.toLowerCase().includes(value.name.toLowerCase())
            )
            .map((value, i) => {
              return (
                <div
                  onClick={() => updateState(value)}
                  className={styles.selectContainerOptionsOption}
                  key={i}
                  tabIndex="0"
                >
                  <span>{value.name}</span>
                </div>
              );
            })}
        </div>
      )}
      {/* {display ? (
        <img
          onClick={() => setDisplay(!display)}
          src={Icons.DropUp}
          alt="land_photo"
        />
      ) : (
        <img
          onClick={() => setDisplay(!display)}
          src={Icons.DropDown}
          alt="land_photo"
        />
      )} */}
    </div>
  );
};

export default SelectInput;
